import { render } from "./MediaGrid.vue?vue&type=template&id=2efc35d0&lang=pug"
import script from "./MediaGrid.vue?vue&type=script&lang=js"
export * from "./MediaGrid.vue?vue&type=script&lang=js"

import "./MediaGrid.vue?vue&type=style&index=0&id=2efc35d0&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__